<ul class="menu-icons-wrap">
  <ng-container *ngFor="let menuElement of menuStructure">
    <li *show="menuElement.permission" class="menu-item tw-flex" (click)="onMenuIconClick(menuElement)">
      <button
        type="button"
        class="tw-self-center"
        mat-icon-button
        [matTooltip]="menuElement.title | translate"
        [matTooltipPosition]="'right'"
      >
        <ui-svg-icon *ngIf="menuElement.icon" [name]="menuElement.icon" class="tw-mr-0"></ui-svg-icon>
      </button>
    </li>
  </ng-container>
</ul>
